import { isTokenExpired } from "../../helpers/auth";
import { authApi } from "../../services/auth";
import store from "../../store";

/** Returns the usable access token, refreshing it when expired, or null when the session is dead. */
const resolveStoredToken = async (accessToken: string, refreshToken: string | null) => {
  if (!isTokenExpired(accessToken)) return accessToken;

  const refreshExpired = refreshToken ? isTokenExpired(refreshToken) : true;
  if (!refreshToken || refreshExpired) return null;

  const { data: refreshAccessToken } = await store.dispatch(
    authApi.endpoints.refreshToken.initiate({ token: refreshToken })
  );

  return refreshAccessToken?.accessToken;
};

export const authLoader = async () => {
  const accessToken = localStorage.getItem("accessToken");
  const refreshToken = localStorage.getItem("refreshToken");

  if (accessToken) {
    return { token: await resolveStoredToken(accessToken, refreshToken) };
  }

  return { token: accessToken };
};
